import { render, staticRenderFns } from "./HorizontalNav.vue?vue&type=template&id=1aa313da&scoped=true&"
import script from "./HorizontalNav.vue?vue&type=script&lang=js&"
export * from "./HorizontalNav.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNav.vue?vue&type=style&index=0&id=1aa313da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa313da",
  null
  
)

export default component.exports